<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      :lock-scroll="true"
      :close-on-popstate="true"
      :style="{
        height: height
      }"
    >
      <template v-if="type == 1">
        <ld-header
          title="温馨提示"
          @click-left="isShow = false"
        />
        <pre style="white-space: pre-line; padding: 0 20px 20px; margin: 0; font-family: auto;">
          1. 一张有效身份证件同一乘车日期同一车次只能购买一张车票。
      
          2. 购票时可使用的有效身份证件包括：中华人民共和国居民身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证和按规定可使用的有效护照。
      
          3. 系统暂不支持学生票。
      
          4. 购买儿童票时，乘车儿童有有效身份证件的，请填写本人有效身份证件信息。乘车儿童没有有效身份证件的，应使用同行成年人的有效身份证件信息（使用同行成年人的姓名及证件号码）；购票时不受第一条限制，但购票后、开车前须办理换票手续方可进站乘车。
      
          5. 如果姓名中有“●”（中点）或“.”（下点）时，请仔细辨析身份证件原件上的“●”或“.”，准确输入。
      
          6. 如果姓名较长，汉字或英文字符合计超过30个（1个汉字算2个英文字符）时，需按姓名中第一个汉字或英文字符开始按顺序连续输入30个字符(空格字符不输入)，其中英文字符不需区别大小写。
      
          7.卧铺上\中\下是随机分配的，实际票价以预订成功后的票价为准。

          8.广深港跨境列车过关：
            ①　内地至香港过关：列车到达西九龙总站后，在B4层月台下车，进入B2层办理内地处境程序，离开内地口岸去，再进入同一层的香港口岸区，办理入境。
            ②　香港至内地过关：在B1层购票、检票入闸，进入B3层办理香港处境程序，离开香港口岸；进入同一层的内地口岸区，办理内地入境程序。
        </pre>
      </template>
      <template v-if="type == 2">
        <ld-header
          title="乘客姓名填写说明"
          @click-left="isShow = false"
        />
        <div class="rzssm">
          <h3>网络购票需验证乘客省份信息</h3>
          <ul>
            <li>请正确填写，乘客身份证件和姓名都通过验证才可以成功出票。</li>
          </ul>

          <h3>乘客姓名填写说明 : </h3>
          <ul>
            <li>使用身份证、回乡证、台胞证预订火车票请优先使用中文姓名。</li>
            <li>如名字中包含生僻字可直接输入拼音代替。例如："王鬳"可输入为"王yan"。</li>
            <li>姓名中有"."或"?"时，请仔细辨析身份证原件上的"."或"?"，准确输入。</li>
            <li>使用护照购票请根据证件所显示的姓名从左到右、从上到下输入姓名。如护照上有中文名，请输入中文名。</li>
            <li>台籍乘客请使用台胞证（台湾居民来往大陆通行证）</li>
            <li>使用外国人永久居留身份证购票，姓名仅支持输入英文或空格。</li>
          </ul>

          <h3>身份未通过核验购票失败怎么办？</h3>
          <ul>
            如身份信息验证未通过造成出票失败，请您持有效证件原件，去火车站或代售点核验购票。<br>
            在车站或代售点核验通过后，下次就可以再网络买票了。
          </ul>
        </div>
      </template>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant'

export default {
  name: 'TrRule',
  components: {
    [Popup.name]: Popup
  },
  data() {
    return {
      isShow: false
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    type: {
      type: String,
      default: '1'
    },
    height: {
      type: String,
      default: '100%'
    },
    visibility: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visibility (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
  
}
</script>

<style lang="less" scoped>
.rzssm {
  padding: 20px;
  padding-left: 40px;
  
  h3 {
    margin-left: -16px;
    margin-top: 0;
  }

  ul {
    margin-bottom: 12px;
  }

  li {
    list-style-type: circle;
    margin: 5px 0;
  }
}
</style>